export function PerfectAttendanceIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="10" y="10" width="28" height="28" rx="3" />
      <line x1="10" y1="18" x2="38" y2="18" />
      <line x1="18" y1="10" x2="18" y2="14" />
      <line x1="30" y1="10" x2="30" y2="14" />
      <path d="M18 26l4 4 8-8" />
    </svg>
  );
}
